module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-4-photo-5-e400a6450bfdc1fbc9a5b36835b83c84.webp";